import * as Actions from "../Actions/EmpresaPessoaFormularioActions";
import _ from "lodash";

const initialState = {
    data: null,
    datapessoa: null,
    error: null,
    warning: null,
    info: null,
    atribuicoes: null,
    template: null,
    formularios: null,
    formDialog: {
        type: "new",
        props: {
            open: false,
        },
        data: null,
    }
};


const EmpresaPessoaFormularioReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_EMPRESAPESSOA_FORMULARIO:
            {
                return {
                    ...state,
                    data: action.payload,
                };
            }
        case Actions.GET_EMPRESAPESSOA:
            {
                return {
                    ...state,
                    datapessoa: !_.isNull(action.payload) ? action.payload[0] : action.payload,
                };
            }
        case Actions.GET_FORMULARIO_INDEX:
            {
                return {
                    ...state,
                    formularios: action.payload
                };
            }
        case Actions.GET_PESSOA_ATRIBUICAO_FORMULARIO:
            {
                return {
                    ...state,
                    atribuicoes: action.payload
                };

            }
        case Actions.GET_EMPRESAPESSOA_FORMULARIO_TEMPLATE:
            {
                return {
                    ...state,
                    template: action.payload

                };
            }
        case Actions.OPEN_NEW_EMPRESAPESSOA_FORMULARIO_DIALOG:
            {
                return {
                    ...state,
                    formDialog: {
                        type: "new",
                        props: {
                            open: true
                        },
                        data: null
                    }
                };
            }
        case Actions.CLOSE_NEW_EMPRESAPESSOA_FORMULARIO_DIALOG:
            {
                return {
                    ...state,
                    formDialog: {
                        type: "new",
                        props: {
                            open: false
                        },
                        data: null
                    }
                };
            }
        case Actions.OPEN_EDIT_EMPRESAPESSOA_FORMULARIO_DIALOG:
            {
                return {
                    ...state,
                    formDialog: {
                        type: "edit",
                        props: {
                            open: true
                        },
                        data: action.data
                    }
                };
            }
        case Actions.CLOSE_EDIT_EMPRESAPESSOA_FORMULARIO_DIALOG:
            {
                return {
                    ...state,
                    formDialog: {
                        type: "edit",
                        props: {
                            open: false
                        },
                        data: null
                    }
                };
            }
        case Actions.EMPRESAPESSOA_FORMULARIO_ERROR:
            {
                return {
                    ...state,
                    error: action.payload
                };
            }
        case Actions.EMPRESAPESSOA_FORMULARIO_INFO:
            {
                return {
                    ...state,
                    info: action.payload,
                    formDialog: {
                        ...state.formDialog,
                        type: "edit",
                        props: {
                            ...state.formDialog.props,
                            id: action.id
                        }
                    }
                };
            }
        case Actions.EMPRESAPESSOA_FORMULARIO_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload
                };
            }
        default:
            {
                return state;
            }
    }
};

const reducer = EmpresaPessoaFormularioReducer;
export default reducer;
